import * as React from "react";
import { SVGProps, memo } from "react";

const SvgPaperless = (props: SVGProps<SVGSVGElement>) => (
  <svg width={41} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.916 29.584h10.917c.354 0 .65-.12.89-.361s.36-.54.36-.896c0-.357-.12-.653-.36-.889a1.218 1.218 0 0 0-.89-.354H14.916c-.354 0-.651.12-.89.361-.24.241-.36.54-.36.896 0 .357.12.653.36.889.239.236.536.354.89.354Zm0-7.083h10.917c.354 0 .65-.12.89-.362.24-.24.36-.54.36-.896s-.12-.652-.36-.888a1.219 1.219 0 0 0-.89-.354H14.916c-.354 0-.651.12-.89.361-.24.241-.36.54-.36.896s.12.652.36.889c.239.236.536.354.89.354ZM9.541 36.667c-.667 0-1.25-.25-1.75-.75s-.75-1.083-.75-1.75V5.834c0-.667.25-1.25.75-1.75s1.083-.75 1.75-.75h14c.346 0 .675.07.988.208.314.14.581.32.804.542l7.625 7.625c.222.222.403.49.541.803.14.313.209.643.209.989v20.666c0 .667-.25 1.25-.75 1.75s-1.084.75-1.75.75H9.54Zm13.792-24.333v-6.5H9.54v28.333h21.667V13.584h-6.625a1.21 1.21 0 0 1-.89-.36 1.21 1.21 0 0 1-.36-.89Z"
      fill="#2B323B"
    />

    <path
      d="M38.373 2 2.375 37.998M2.378 2l35.997 35.998"
      stroke="#2B323B"
      strokeWidth={3}
      strokeLinecap="round"
    />
  </svg>
);

const Memo = memo(SvgPaperless);

export default Memo;
